import { Column, Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';

import { createTheme as createDSTheme } from 'app/shopify';
import { IconX } from '@tabler/icons-react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
const theme = createDSTheme();

const CURRENT_DAY_COLUMN_BG = '#E0F7F5';

interface DaysRowProps {
  currentDay: number;
  completedDays: number[];
  missedDays?: number[];
  totalDays: number;
  showIceCube?: boolean;
  hasContributedToday?: boolean;
}

export const DaysRow = function DaysRow({
  currentDay,
  completedDays,
  missedDays = [],
  totalDays,
  showIceCube = false,
  hasContributedToday = true,
}: DaysRowProps) {
  const days = Array.from({ length: totalDays }, (_, i) => i + 1);
  const missedSet = new Set(missedDays);
  const completedSet = new Set(completedDays);

  return (
    <Row
      backgroundColor="white"
      borderRadius="radius.lg"
      justifyContent="space-between"
      paddingVertical="spacing.general.x2"
      paddingHorizontal="spacing.general.x1"
    >
      {days.map((day) => {
        const isMissed = missedSet.has(day);
        const isCompleted = completedSet.has(day);
        const isCurrent = day === currentDay;
        const isFuture = day > currentDay;

        const dayLabelColor = isCurrent
          ? 'text.primary'
          : isFuture || isMissed
            ? 'text.secondary'
            : isCompleted
              ? 'text.primary'
              : 'text.secondary';

        const icon = (() => {
          if (isMissed && showIceCube) {
            return (
              <Text fontSize={18} lineHeight={24} textAlign="center">
                🧊
              </Text>
            );
          }
          if (isMissed && !showIceCube) {
            return (
              <Column
                alignItems="center"
                backgroundColor="surface.tertiary-neutral"
                borderRadius="radius.full"
                height={22}
                justifyContent="center"
                width={22}
              >
                <IconX strokeWidth={ICON_STROKE_WIDTH} size={11} color={theme.colors['text.placeholder']} />
              </Column>
            );
          }
          if (isCompleted) {
            return (
              <Text fontSize={18} lineHeight={24} textAlign="center">
                🔥
              </Text>
            );
          }
          if (isFuture) {
            return <Column backgroundColor="surface.disabled" borderRadius="radius.xxl" height={20} width={20} />;
          }
          if (isCurrent && !hasContributedToday) {
            return (
              <Column
                alignItems="center"
                borderColor="text.brand"
                borderRadius="radius.full"
                borderWidth={2}
                height={22}
                justifyContent="center"
                width={22}
              />
            );
          }
          return <Column backgroundColor="surface.disabled" borderRadius="radius.xxl" height={20} width={20} />;
        })();

        return (
          <Column key={day} alignItems="center" flex={1}>
            <Column
              alignItems="center"
              borderRadius="radius.lg"
              gap="spacing.general.x1"
              paddingHorizontal="spacing.general.x1"
              paddingVertical="spacing.general.x1"
              style={isCurrent ? { backgroundColor: CURRENT_DAY_COLUMN_BG } : undefined}
              maxWidth={48}
              width="100%"
            >
              <Text color={dayLabelColor} fontSize={14} fontWeight={isCurrent ? '600' : '500'}>
                {day}
              </Text>
              <Column alignItems="center" justifyContent="center" height={24} width={24}>
                {icon}
              </Column>
            </Column>
          </Column>
        );
      })}
    </Row>
  );
};
